import { IUserInfo } from "@uxland/primary-shell";
import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

// Global variable to hold shellApi reference
let shellApiRef: any = null;

// Function to set the shellApi (called from plugin initialization)
export const setShellApiForOwnSpec = (api: any) => {
  shellApiRef = api;
};

export class OwnSpec extends Spec<IActivityHistoryItem> {
  constructor(public context: IActivityHistoryItem) {
    super();
  }
  isSatisfiedBy(context: IActivityHistoryItem): boolean {
    // If no shellApi is available, return false (e.g., during tests)
    if (!shellApiRef) {
      return false;
    }
    
    try {
      const userInfo = shellApiRef.globalStateManager.getData("userInfo") as IUserInfo;
      return context?.professional?.id === userInfo?.userId;
    } catch {
      return false;
    }
  }
}
